<template>
  <footer class="py-5" id="footer-main">
    <b-container>
      <b-row align-v="center" class="justify-content-between">
        <div class="col-lg-3 col-md-12 col-sm-12">
          <div class="copyright-box-design text-lg-left text-center mb-3">
            <p><b>Copyright</b> &copy; {{ year }}&nbsp;Digital Communications Consulting LLC. <br>All Rights Reserved.
            </p>
            <a href="http://www.dccllc.net/privacy-policy/" title="Privacy Policy" target="_parent" class="mb-5">Privacy
              Policy</a>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <b-row>
            <b-col lg="4" sm="12" class="text-lg-left text-center">
              <p>The DCC family of companies:</p>
            </b-col>
            <b-col lg="8" sm="12" class="text-lg-left text-center mb-3 d-flex justify-content-evenly">
              <div>
                <img alt="DCS Consulting logo" src="/img/brand/dcc_consulting.png">
              </div>
              <div>
                <img alt="DCC Signaling logo" src="/img/brand/dcc_signaling.png">
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="col-lg-3 col-md-12 col-sm-12">
          <div class="designed-by-box-design text-lg-left text-center">
            <p>
              Developed by: <a href="#" title="FuzeMobi" target="_blank">FuzeMobi, LLC.</a> <br>
              Designed by: <a href="#">Chad Rosenbohm</a><br>
              UX Version: {{ uxVersion }} <br>
              API Version: {{ apiVersion }} <br>
            </p>

          </div>
        </div>
      </b-row>
    </b-container>
    <b-container fluid class="float-sticky p-0" style="padding-left:0!important; padding-right: 0!important">
      <b-row class="d-flex  ml-0" id="navBottom">
        <b-row class="d-flex justify-content-between w-100  ml-1 mr-1" v-if="!isModal && showLogStatus">
          <b-col cols="5">
            <div class="text-left nowrap">
              <span class="cursor-pointer">Activity</span> :
              <span v-if="!loadingStatus">{{ activity.method }} &nbsp; ... </span>
              <span v-if="loadingStatus"><i class="fas fa-spinner fa-spin mr-3">  </i> </span>
              <span class="cursor-pointer " v-on:click="showModal(activity)"
                    v-if="!loadingStatus">click here for more </span>
            </div>
          </b-col>
          <b-col cols="2" class="text-center">
            <div @click="isModal = true; openConsoleModal()">
              <b-icon
                  icon="arrows-expand"
                  class="text-center navBottom-icon"
                  font-scale="1"
                  v-b-tooltip.hover.topright="'Click here to open activity'"
              ></b-icon>
            </div>
          </b-col>
          <b-col cols="5">
            <div class="text-right nowrap">ACTIVE: {{ activeTime }} &nbsp; LOGOUT IN {{ logoutTime }}</div>
          </b-col>
        </b-row>
        <swipe-modal
            id="swipe-modal-content"
            v-model="isModal"
            contents-height="20vh"
            border-top-radius="16px"
        >
          <b-table
              striped hover
              :items="tableData"
              :fields="tableColumns"
              head-variant="light"
              table-class="text-nowrap"
              class="data-management-table primary-table"
              sticky-header="true"
              thead-class="white"
              show-empty
              responsive
              small
          >
            <template #cell(response)="row">
              <!--              <div v-highlight>-->
              <!--              <pre>-->
              <!--                <code class="json">{{ row.item.response }}</code>-->
              <!--              </pre>-->
              <!--              </div>-->
              <base-button type="primary" title="Show Details" size="sm" v-on:click="showModal(row.item.response)">
                Show Details
              </base-button>

            </template>

          </b-table>
          <!-- <div v-for="(item, key) in activities" v-bind:key="key" class="ml-3"> -->
          <!-- <span class="cursor-pointer">LOG CONSOLE :</span>
          <span class="cursor-pointer ml-3" :style="item.textColor"> {{item.method}} &nbsp; ... </span>
          <span class="cursor-pointer " v-on:click="showModal(item)"><u>click here for more</u></span>  -->

          <!-- </div> -->
        </swipe-modal>
      </b-row>
    </b-container>
    <b-modal title="Details" ok-only centered id="open_console">
          <span class="responsive-table">
          <div v-highlight class="overflow-auto w-auto h-auto">
            <pre><code class="json" style="max-height: 50vh!important">{{ fJson(modalContent) }}</code></pre>
          </div>
          </span>
    </b-modal>

  </footer>
</template>

<script>
import initService from "../../common/api-services/init-service";
import authService from '../../common/api-services/auth-service';
import {mapGetters} from "vuex";
import swipeModal from '@takuma-ru/vue-swipe-modal';
import coreutils from "@/common/coreutils";

let VUE_APP_SESSION_TIMEOUT_MINUTES = `${process.env.VUE_APP_SESSION_TIMEOUT_MINUTES}`;

export default {

  components: {
    swipeModal
  },
  data() {
    return {
      year: new Date().getFullYear(),
      activeTime: '',
      logoutTime: '',
      timeIncrease: 0,
      range: '1_wk',
      activity: [],
      activities: [],
      expand: false,
      modalContent: '',
      loadingStatus: true,
      loginTime: '',
      isModal: false,
      showLogStatus: false,
      totalRows: 0,
      currentPage: 1,
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      tableColumns: [
        {key: 'actiondate', label: 'Date', sortable: true, sortDirection: 'desc'},
        {key: 'method', label: 'Action', sortable: true, sortDirection: 'desc'},
        {key: 'user', label: 'User', sortable: true, sortDirection: 'desc'},
        {key: 'fault', label: 'Error', sortable: true, sortDirection: 'desc'},
        {key: 'response', label: 'Message', sortable: true, sortDirection: 'desc'}
      ],
      tableData: [],
      localData: [],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      apiVersion: '',
      uxVersion: '',
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
  },
  watch: {
    isIdle(c) {
      if (!c) {
        this.getLogoutIn();
      }
    }
  },
  mounted() {
    if (this.isAuthenticated) {
      let token = sessionStorage.getItem('accessToken')
      this.getActive(token);
      this.showLogStatus = false;
      this.getConsole();
      this.getVersions();
    }
    this.getLogoutIn();
  },

  methods: {

    fJson(text) {
      return coreutils.formatJson(text);
    },


    getVersions() {
      this.uxVersion=initService.getUxVersion();
      initService.getApiVersion().then((res) => {
        this.apiVersion=res.toString();
      });
    },

    getActive(token) {
      if (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        this.loginTime = JSON.parse(jsonPayload).auth_time

        setInterval(() => {
          let timestamp = new Date().getTime() - this.loginTime * 1000;
          this.activeTime = new Date(timestamp).toISOString().slice(11, 19);
        }, 1000);
      }
    },

    getLogoutIn() {
      let time = VUE_APP_SESSION_TIMEOUT_MINUTES * 60000;
      setInterval(() => {
        this.logoutTime = new Date(time).toISOString().slice(11, 19);
        time -= 1000;
      }, 1000)
    },

    getConsole() {
      authService.getTransactionHistory(this.range).then(res => {
        if (res !== 'No data found' && typeof res !== "string") {
          this.loadingStatus = false
          this.activity = res[0]
          let data = res.map(d => {
            try {
              d.response = JSON.parse(d.response);
            } catch (e) {
            }
            return d
          });
          this.tableData = data.slice(0, 10);
        }
      })
    },

    showModal(content) {
      if (content) {
        this.modalContent = (content.response);
        this.$bvModal.show('open_console');
      }
    },

    openConsoleModal() {
      this.$sidebar.displaySidebar(false);
    }

  },
}
</script>